export const SETUP_APPLICATION = 'SETUP_APPLICATION'
export const SETUP_MOBILE = 'SETUP_MOBILE'
export const SETUP_PROJECTS = 'SETUP_PROJECTS'
export const NOTIFY_HONEYBADGER = 'NOTIFY_HONEYBADGER'
export const START_AUTOSAVE_SAGA = 'START_AUTOSAVE_SAGA'
export const AUTOSAVE = 'AUTOSAVE'
export const APPLY_CAMERA_DATA = 'APPLY_CAMERA_DATA'
export const LOGIN_AND_RESTART_APP = 'LOGIN_AND_RESTART_APP'
export const UPDATE_CURRENT_ENTITY = 'UPDATE_CURRENT_ENTITY'
export const PROJECT_EXPANDED = 'PROJECT_EXPANDED'
export const LOCK_PROJECT = 'LOCK_PROJECT'
export const REMOVE_CATCH_EARLY_FLAG = 'REMOVE_CATCH_EARLY_FLAG'
export const UPDATE_UPDATED_AT = 'UPDATE_UPDATED_AT'
export const REMOVE_LEGACY_PROJECT = 'REMOVE_LEGACY_PROJECT'
export const SETUP_MANUALLY_LOADED_EXPORT = 'SETUP_MANUALLY_LOADED_EXPORT'
export const RESET_SPECIFIC_MANUFACTURER_AND_RESTART_APP = 'RESET_SPECIFIC_MANUFACTURER_AND_RESTART_APP'
export const REMOVE_MANUFACTURER_SPECIFIC_CAMERAS = 'REMOVE_MANUFACTURER_SPECIFIC_CAMERAS'
export const REMOVE_MANUFACTURER_SPECIFIC = 'REMOVE_MANUFACTURER_SPECIFIC'
export const ADD_DATABASE_CONFIG_INSTANCE = 'ADD_DATABASE_CONFIG_INSTANCE'
export const REVERSE_GEOCODE_LOCATION = 'REVERSE_GEOCODE_LOCATION'
export const SHOW_MOBILE_START = 'SHOW_MOBILE_START'
export const HIDE_MOBILE_START = 'HIDE_MOBILE_START'
export const SHOW_MOBILE_ERROR = 'SHOW_MOBILE_ERROR'
export const STORE_OFFLINE = 'STORE_OFFLINE'
export const STORE_ACTIVE = 'STORE_ACTIVE'
export const SIGN_IN = 'SIGN_IN'
export const WAIT_FOR_MAP_IDLE = 'WAIT_FOR_MAP_IDLE'
export const CHECK_OFFLINE_LIMITS = 'CHECK_OFFLINE_LIMITS'



// WEBPACK FOOTER //
// ./src/actions/applicationActionTypes.js